const contactPage = $('#contactForm').length;

export function contactFunc() {

  if (contactPage) {
    
          /* ----------------------------------------------------------------------------------
    モーダルウィンドウ
    ---------------------------------------------------------------------------------- */
    var detailModalFunc = {
      init: function(onLoad) {
        if(onLoad) this._init();
      },
      _init: function() {
        // 設定
        var animateSpeed = 2000;
        var closeElem = '.close a';
        var btnCloseElem = '.closeBtn';
        var mainModalContent = '.detailModalContent';
        var myModalHeight;
        var pointScrollY;
        var currentScrollY;
  
        $(window).scroll(function() {
          pointScrollY = $(window).scrollTop();
        });
  
        // スライドされる高さの調整
         $(window).on('load resize', function() {
           var windowHeight = $(window).outerHeight();
           $(mainModalContent).find('.modalInner').css({'height':windowHeight}); //高さを出すスクロールを表示
         });
  
        $(mainModalContent).each(function(i) {
          i++;
          //console.log(i);
          $('.modal' + i).on('click touchstart', function() {
            // 背景固定
             currentScrollY = $(window).scrollTop();
            $('body').css({
              position: 'fixed',
              width: '100%',
              top: -1 * currentScrollY,
            });
  
            $('#modal' + i).fadeIn(animateSpeed);
  
            // 上下縦横中央寄せに実行
            var windowHeight = $(window).outerHeight(); // 縦方向の余白を保つ
            myModalHeight = $('#modal' + i).outerHeight();
            if(windowHeight <= myModalHeight) {
              myModalHeight = windowHeight;
              $(mainModalContent).css({'height':'100%'});
            }
            centeringModalSyncer(myModalHeight);
          });
  
          function closeAction() {
            // 背景を固定を解除
            $('body').attr({style:''});
            $('html,body').animate({scrollTop:currentScrollY},1);
            $(mainModalContent).stop().fadeOut(animateSpeed);
          }
  
          // クリックでモーダルをクローズ
          $(closeElem).on('click', function() {
            closeAction();
          });
        });
        $(window).on('resize', centeringModalSyncer);
  
        // 上下縦横中央寄せの関数
        function centeringModalSyncer(myModalHeight) {
          $(mainModalContent).css({
            'left': '0px',
            'top': '0px'
          });
        }
      }
    }
    detailModalFunc.init(true);


    const typeSelect = $("[name='type']");
    let selectIndex = '';

    const formField = $('#formField');
    formField.addClass('isShow');

    // お問い合わせ種別
    const selectControl = function () {
      for (var val = "", i = typeSelect.length; i--;) {
        if (typeSelect[i].checked) {
          var val = typeSelect[i].value;
          break;
        }
      }
      selectIndex = val;
      if (selectIndex != '') {
        if (selectIndex == 'online') {
          $('#online').addClass('isShow');
        } else {
          formField.addClass('isShow');
          if (selectIndex == 'business') {
            $('#business').addClass('isShow');
            $('.business').addClass('isShow');
          } else {
            $('#basic').addClass('isShow');
            if (selectIndex == 'product') {
              $('.product').addClass('isShow');
            } else if (selectIndex == 'inferior') {
              $('.inferior').addClass('isShow');
            } else if (selectIndex == 'interview') {
              $('.interview').addClass('isShow');
            } else if (selectIndex == 'other') {
              $('.other').addClass('isShow');
            }
          }
        }
      }
    }

    // 必須項目名
    const companyName = $("[name='companyName']");
    // const mediaName = $("[name='mediaName']");
    const contactName = $("[name='contactName']");
    const myName = $("[name='myName']");
    const email = $("[name='email']");
    const emailCheck = $("[name='emailCheck']");
    const telNumber = $("[name='telNumber']");
    const subject = $("[name='subject']");
    const product = $("[name='product']");
    const content = $("[name='content']");
    const businessCompanyName = $("[name='businessCompanyName']");
    const yearMonth = $("[name='yearMonth']");
    const capital = $("[name='capital']");
    const employeeNum = $("[name='employeeNum']");
    const tradingCompany = $("[name='tradingCompany']");
    const annualSales = $("[name='annualSales']");
    const businessContactName = $("[name='businessContactName']");
    const postalCode = $("[name='postalCode']");
    const companyAddress = $("[name='companyAddress']");
    // const companyTelNumber = $("[name='companyTelNumber']");
    const companyEmail = $("[name='companyEmail']");
    const companyEmailCheck = $("[name='companyEmailCheck']");
    // const tradingProducts = $("[name='tradingProducts']");
    const tradingPlans = $("[name='tradingPlans']");
    const tradingCountry = $("[name='tradingCountry']");
    const salesForms = $("[name='salesForms']");
    const monthlySales = $("[name='monthlySales']");
    const otherRequest = $("[name='otherRequest']");
    const agreeCheck = $("[name='agreeCheck']");

    const age = $("[name='age']");
    const country = $("[name='country']");

    // 必須項目定義
    // const onlineRequired = [myName, email, emailCheck, subject, content, agreeCheck];
    // const productRequired = [myName, email, emailCheck, product, content, agreeCheck];
    // const inferiorRequired = [myName, email, emailCheck, product, content, agreeCheck];
    // const businessRequired = [businessCompanyName, yearMonth, capital, employeeNum, tradingCompany, annualSales, businessContactName, postalCode, companyAddress, companyEmail, companyEmailCheck, tradingPlans, tradingCountry, salesForms, monthlySales, agreeCheck];
    // const interviewRequired = [companyName, contactName, email, emailCheck,  content, agreeCheck];
    const otherRequired = [subject, myName, age, country, email, emailCheck, telNumber, content, agreeCheck];

    // 必須項目設定
    let requiredField = [];
    const requiredFieldSet = function () {
      requiredField = otherRequired;
      for (let i = 0; i < requiredField.length; i++) {
        let requiredFieldType = requiredField[i].attr('type');
        if (requiredFieldType == 'radio' || requiredFieldType == 'checkbox') {
          requiredField[i].change(function () {
            fieldCheck(requiredField[i]);
          });
        } else {
          requiredField[i].blur(function () {
            fieldCheck(requiredField[i]);
          });
        }
      }
    }

    // リロード時実行
    //selectControl();
    requiredFieldSet();

    // セレクト選択時実行
    typeSelect.change(function () {
      formField.removeClass('isShow');
      $('.split').removeClass('isShow');
      selectIndex = typeSelect.val();
      //selectControl();
      requiredFieldSet();
    });

    const agreeCheckTxt = "Veuillez cocher la case « J'accepte la Politique de confidentialité »";
    const emailRequiredTxt = 'Veuillez saisir votre adresse e-mail correcte';
    const emailDuplication = 'Cette adresse e-mail est différente de celle que vous avez indiquée dans le formulaire ci-dessus';
    const telRequiredTxt = 'Veuillez saisir un nombre de 10 à 12 chiffres';

    let errorTxt = '';
    const fieldCheck = function (checkField, all = false) {
      let checkFieldValue = checkField.val();
      let checkFieldType = checkField.attr('type');
      let checkFieldTag = checkField[0].tagName;
      let checkFieldName = checkField.attr('name');
      let checkFieldLabel = $('[for= ' + checkFieldName + ']');
      let checkFieldLabelTxt = checkFieldLabel.text().replace("*Obligatoire", "");;
      if (checkFieldType == 'radio') {
        errorTxt = '*Obligatoire';
        if (!checkField.is(':checked')) {
          checkField.parents('.radioArea').addClass('error').next('.errorTxt').text(errorTxt);
        } else {
          checkField.parents('.radioArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField == agreeCheck) {
        if (!checkField.is(':checked')) {
          checkField.parents('.checkboxArea').addClass('error').next('.errorTxt').text(agreeCheckTxt);
        } else {
          checkField.parents('.checkboxArea').removeClass('error').next('.errorTxt').text('');
        }
      } else if (checkField.hasClass('select')) {
        errorTxt = '*Obligatoire';
        if (checkFieldValue == '') {
          checkField.addClass('error').parent('.selectBtn').next('.errorTxt').text(errorTxt);
        } else {
          checkField.removeClass('error').parent('.selectBtn').next('.errorTxt').text('');
        }
      } else if (checkFieldName == 'tradingProducts') {
        errorTxt = '*Obligatoire';
        if (!checkField.is(':checked')) {
          checkField.parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
        } else {
          checkField.parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
        }
      } else {
        errorTxt = '*Obligatoire';
        if (checkFieldName == 'content' && selectIndex != 'inferior') {
          errorTxt = '*Obligatoire';
        }
        if (checkFieldValue == '') {
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkFieldType == 'email' && !checkFieldValue.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
          checkField.addClass('error').next('.errorTxt').text(emailRequiredTxt);
        } 
        else if (checkField == emailCheck && checkFieldValue != email.val()) {
          checkField.addClass('error').next('.errorTxt').text(emailDuplication);
        } 
        else if (checkField == companyEmailCheck && checkFieldValue != companyEmail.val()) {
          checkField.addClass('error').next('.errorTxt').text(emailDuplication);
        } 
        else if (checkField == email && checkFieldValue.length >= 51) {
          errorTxt = "Veuillez saisir jusqu'à 50 caractères";
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkFieldType == 'tel' && !checkFieldValue.match('^[0-9]{10,12}$')) {
          checkField.addClass('error').next('.errorTxt').text(telRequiredTxt);
        } 
        else if (checkField == telNumber && checkFieldValue.length >= 21) {
          errorTxt = "Veuillez saisir jusqu'à 20 caractères";
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkFieldTag == 'TEXTAREA' && checkFieldValue.length >= 501) {
          errorTxt = "Veuillez saisir jusqu'à 500 caractères";
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == myName && checkFieldValue.length >= 51) {
          errorTxt = "Veuillez saisir jusqu'à 50 caractères";
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == age && checkFieldValue.length >= 4) {
          errorTxt = "Veuillez saisir jusqu'à 3 caractères";
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        } 
        else if (checkField == age && !checkFieldValue.match('^[0-9]')) {
          errorTxt = '*This field must be filled with numbers only.';
          checkField.addClass('error').next('.errorTxt').text(errorTxt);
        }
        else {
          checkField.removeClass('error').next('.errorTxt').text('');
        }
      }
    };

    otherRequest.blur(function () {
      if (otherRequest.val().length >= 501) {
        errorTxt = "Veuillez saisir jusqu'à 500 caractères";
        otherRequest.addClass('error').next('.errorTxt').text(errorTxt);
      } else {
        otherRequest.removeClass('error').next('.errorTxt').text('');
      }
    });

    if (selectIndex == 'business') {
          $('.tradingProducts').on('change', function(){
      var r = $('.tradingProducts:checked').length > 0;
      errorTxt = '*Obligatoire';

      if(r){
        $(this).parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
      }else{
        $(this).parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
      }
    });
    }

    function is_checked(){
      if (selectIndex == 'business') {
          var cnt = 0;
          cnt += $('.tradingProducts:checked').length;
          errorTxt = '*Obligatoire';
    
          if(cnt > 0){
            $('.tradingProducts').parents('.checkboxArea02').removeClass('error').next('.errorTxt').text('');
          }else{
            $('.tradingProducts').parents('.checkboxArea02').addClass('error').next('.errorTxt').text(errorTxt);
          }
          
          return cnt;
      }
    }
    
    let sendBtn = $('#sendBtn');
    // 各項目をサブミット処理でチェック（個人、法人フォーム）
    $('form').submit(function (e) {
      // 初期設定
      let set = 0;
      if (set == 0) {
        set = 1;
      } else {
        return false;
      }

      // 各項目をチェック（個人フォーム用）
      for (let i = 0; i < requiredField.length; i++) {
        fieldCheck(requiredField[i]);
      }

      is_checked();

      // エラー箇所があればその場所までスクロール
      let offsetTxt, headerHeight;
      if ($('.errorTxt').text() != '') {
        offsetTxt = $('.error').offset().top;
        headerHeight = $('#header').outerHeight();
        $('html,body').animate({
          scrollTop: offsetTxt - headerHeight
        }, 500);
        return false;
      }

      // エラーがなければ二重送信禁止
      sendBtn.prop('disabled', 'true');
      setTimeout(function () {
        sendBtn.prop('disabled', '');
      }, 1000);
      return true;
    });

    // ラジオボタンチェック時入力欄有効可
    const radioBtn = document.querySelectorAll('.radioBtn');
    const radioField = document.querySelectorAll('.radioField');
    for (let i = 0; i < radioBtn.length; i++) {
      if (radioBtn[i].checked) {
        radioField[i].disabled = false;
      } else {
        radioField[i].disabled = true;
      }
    }
    $("input[type='radio']").on('click', function () {
      for (let i = 0; i < radioBtn.length; i++) {
        if (radioBtn[i].checked) {
          radioField[i].disabled = false;
        } else {
          radioField[i].disabled = true;
          radioField[i].value = '';
        }
      }
    });

    // チェックボックスチェック時入力欄有効可
    const checkBtn = document.querySelectorAll('.checkBtn');
    const checkField = document.querySelectorAll('.checkField');
    for (let i = 0; i < checkBtn.length; i++) {
      if (checkBtn[i].checked) {
        checkField[i].disabled = true;
        checkField[i].value = '';
      } else {
        checkField[i].disabled = false;
      }
    }
    $(".checkboxArea input[type='checkbox']").on('click', function () {
      for (let i = 0; i < checkBtn.length; i++) {
        if (checkBtn[i].checked) {
          checkField[i].disabled = true;
          checkField[i].value = '';
        } else {
          checkField[i].disabled = false;
        }
      }
    });

        // チェックボックスチェック時入力欄有効可
        const checkBtn02 = document.querySelectorAll('.checkBtn02');
        const checkField02 = document.querySelectorAll('.checkField02');
        for (let i = 0; i < checkBtn02.length; i++) {
          if (checkBtn02[i].checked) {
            checkField02[i].disabled = false;
          } else {
            checkField02[i].disabled = true;
            checkField02[i].value = '';
          }
        }
        $(".checkboxArea02 .checkBtn02").on('click', function () {
          for (let i = 0; i < checkBtn02.length; i++) {
            if (checkBtn02[i].checked) {
              checkField02[i].disabled = false;
            } else {
              checkField02[i].disabled = true;
              checkField02[i].value = '';
            }
          }
        });


        let getUrl = location.host;
        var post,api02;
        
        if(getUrl == 'iroha-brandsite-renewal-fr.test'){
          post = {
            site_url: 'http://iroha-brandsite-renewal-fr.test/fr', //WPで記事を追加しているサイトURLを記述してください
          };
          api02 = post.site_url + "/wp-json/wp/v2/pages/3163";
        }else if(getUrl == 'localhost:3000'){
          post = {
            site_url: 'http://iroha-brandsite-renewal-fr.test/fr', //WPで記事を追加しているサイトURLを記述してください
          };
          api02 = post.site_url + "/wp-json/wp/v2/pages/3163";
        }else if(getUrl == 'iroha-tenga.com'){
          post = {
            site_url: 'https://iroha-tenga.com/fr', //WPで記事を追加しているサイトURLを記述してください
          };
          api02 = post.site_url + "/wp-json/wp/v2/pages/5832";
        }else if(getUrl == 'dev-iroha.acceptee-tenga.com'){
          post = {
            site_url: 'http://dev-iroha.acceptee-tenga.com/fr', //WPで記事を追加しているサイトURLを記述してください
          };
          api02 = post.site_url + "/wp-json/wp/v2/pages/5832";
        } else if(getUrl == 'dev.iroha-tenga.com'){
          post = {
            site_url: 'https://dev.iroha-tenga.com/fr', //WPで記事を追加しているサイトURLを記述してください
          };
          api02 = post.site_url + "/wp-json/wp/v2/pages/5832";
        } 

        //アイキャッチを取得したい場合は[&_embed]を追加する 
        var api = post.site_url + "/wp-json/wp/v2/faq/?per_page=100&?wpse_custom_order=menu_order&order=asc";
   
        $.getJSON( api, function(results) {
          $.each(results, function(i, item) {
            //各項目を変数へ格納 
            var link = item.link;//記事のリンク

            var faq_list_thumbnail = item.CUSTOM_REST_API_KEY[0][0];
            var faq_list_thumbnail01 = item.CUSTOM_REST_API_KEY[1][0];
            var faq_list_thumbnail02 = item.CUSTOM_REST_API_KEY[2][0];
            var faq_list_thumbnail02 = item.CUSTOM_REST_API_KEY[2][0];
            var faq_list_alt = item.meta_field.faq_thumbnail_alt;
             
            //指定のクラスへ投稿を追加
            $('#faqList').append("<li class='animeLinkParent'><div class='img animeLinkEachImg'><a href='" + link + "'><img src ='" + faq_list_thumbnail + "' alt='' class='pcOnly'><img src='" + faq_list_thumbnail01 + "' alt='" + faq_list_alt +"' class='pcOnly'><img src='" + faq_list_thumbnail02 + "' alt='" + faq_list_alt +"' class='spOnly'></a></div></li>");
          });
        });

        //アイキャッチを取得したい場合は[&_embed]を追加する 
        $.getJSON( api02, function(results02) {

          for (let i = 0; i < results02.acf.lot_num_repeat.length; i++) {
            var title = results02.acf.lot_num_repeat[i].lot_num_products;
            var content = results02.acf.lot_num_repeat[i].lot_num_con;
            $('#modalDateList').append("<dt>" + title + "</dt><dd>" + content + "</dd>");
          }
        });
  }
}